import { Sites } from '@labradorsports/constants';

import basketball from './lib/basketball/index.js';
import football from './lib/football/index.js';
import lacrosse from './lib/lacrosse/index.js';

export const SportRenderingConfigs = {
    [Sites.lacrosselab]: lacrosse,
    [Sites.hoopslab]: basketball,
    [Sites.footballlab]: football,
};

export * from './lib/components/index.js';
export * from './lib/providers/index.js';
export * from './lib/models/index.js';
export * from './lib/utils/index.js';
export * from './lib/plugins/index.js';
export * from './lib/football/move-placement-frame.js';
